import React from "react"
import ErrorText from "@irati/ui/src/ErrorText"
import Flex from "@irati/ui/src/Flex"
import FormattedMessage from "@irati/utils/lang"
import FormattedErrorText from "../../../components/styled/FormattedErrorText"
import {useBudgetManagement} from "../hooks"
import styled, {css} from "styled-components"

const Span = styled.span<{color: string}>`
  ${({color, theme}) => css`
    background-color: ${color};
    padding: 2px 4px;
    border-radius: 4px;
    color: ${theme.colors.greys.white};
    line-height: 22px;
  `}
`

export function FormErrors() {
  const {state} = useBudgetManagement()
  const {updateError, formErrors} = state

  return (
    <Flex gap={2} direction="column">
      {updateError && <FormattedErrorText error={updateError} />}
      {formErrors &&
        formErrors.map((err) => (
          <ErrorText key={err.id}>
            {err.values?.type === "colors" ? (
              <FormattedMessage
                id={err.id}
                values={{
                  names: (
                    <span>
                      {err.values.names.map((color) => (
                        <Span key={color} color={color}>
                          {" "}
                          {color}{" "}
                        </Span>
                      ))}
                    </span>
                  )
                }}
              />
            ) : (
              <FormattedMessage id={err.id} values={err.values} />
            )}
          </ErrorText>
        ))}
    </Flex>
  )
}
